import React from 'react';
import { useLanguage } from './LanguageContext';
export const UrgencyBanner = () => {
  const {
    t
  } = useLanguage();
  return <div className="bg-brand-red text-white py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2 z-50 relative" data-id="element-928">
      <span className="relative flex h-3 w-3" data-id="element-929">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-930"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" data-id="element-931"></span>
      </span>
      {t.urgency}
    </div>;
};